// ABOUTME: Export file for the Statistics page module
// ABOUTME: Provides lazy-loaded Statistics component

import { lazy } from "react"

export const Statistics = lazy(() => import("./statistics"))
